import React from 'react';
import { useConfig } from '../../ConfigContext';
import { handleAddToCart, handleUpdate } from '../../../services/api';

export function AddToCart() {
  const {
    general,
    music,
    socials,
    croppers,
    selectedLayout,
    multipleGap,
    croppersCount,
  } = useConfig();

  let cartData = {};
  if (general.glassType === 'socials') {
    cartData = {
      general,
      socials,
    };
  } else if (general.glassType === 'music') {
    cartData = { general, music, w: window.innerWidth, h: window.innerHeight };
  } else if (general.glassType === 'multiple') {
    cartData = {
      croppers,
      general: { ...general, imageUrl: null, zoom: 1 },
      selectedLayout,
      multipleGap,
      croppersCount,
    };
  } else {
    cartData = { general };
  }

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  return (
    <div className="flex items-center gap-4 mt-6">
      <span className="text-xl font-bold">{general.total} Kč</span>
      {!general.cartKey ? (
        <button
          disabled={isSubmitting}
          className="submit-custom"
          onClick={() => {
            setIsSubmitting(true);
            handleAddToCart(cartData);
          }}
        >
          {isSubmitting ? 'Načítání' : 'Přidat do košíku'}
        </button>
      ) : (
        <button
          disabled={isSubmitting}
          className="submit-custom"
          onClick={() => {
            setIsSubmitting(true);
            handleUpdate(cartData, general.cartKey);
          }}
        >
          {isSubmitting ? 'Načítání' : 'Uložit'}
        </button>
      )}
    </div>
  );
}
